const $ = window.jQuery;

export default class Media {
  constructor(small = 300, medium = 600, large = 1024, huge = Infinity) {
    this.breakpointMap = new Map([
      ['small', small],
      ['medium', medium],
      ['large', large],
      ['huge', huge],
    ]);

    this.checkCurrentSize();
    window.addEventListener('resize', this.checkOnResize.bind(this));
  }

  checkCurrentSize() {
    this.breakpointMap.forEach((value, key) => {
      if ($(window).width() >= value) {
        this[key] = true;
      } else {
        this[key] = false;
      }
    });
  }

  checkOnResize() {
    const mediaResizedEvent = new CustomEvent('media.resized');

    window.clearTimeout(this.resizeTimeout);
    this.resizeTimeout = window.setTimeout(() => {
      this.checkCurrentSize();
      window.dispatchEvent(mediaResizedEvent);
    }, 100);
  }
}
